import React, { useState, useContext } from "react";
import { api } from "../../api";
import Ctx from "../../contexts/AppContext";
import { btnP, crd } from "../../constants/styles";
import Fld from "../common/Fld";

function TenSubMaint() {
    const { t, h, mts, setMts, tens, pays, go, flash, currUserId, addNotif } = useContext(Ctx);
    const ct = currUserId;
    const [desc, sD] = useState("");
    const [urg, sG] = useState("med");
    const [busy, setBusy] = useState(false);
    const me = tens.find(x => x.id === ct);

    // ── UNLINKED-TENANT GUARD ─────────────────────────────────────────
    // Same pattern as TenPayNow. A tenant whose tenants.org_id is missing
    // or 'org_default' has no landlord to send a maintenance request to.
    // The server now rejects the write with 403 (server/routes/maintenance.js),
    // but if we let the form render, tapping Submit dumps an "Error" toast
    // and — before today's server fix — leaked a maintenance row into
    // org_default with the seed landlord receiving "fan problem urgent"
    // from a stranger.
    //
    // NB: must come AFTER all hooks declared above (rules-of-hooks).
    const isLinked =
        !!me && (
            (me.org_id && me.org_id !== 'org_default') ||
            !!me.pid ||
            (pays || []).some(x => x.tid === ct)
        );
    if (!isLinked) {
        return (
            <div style={{ paddingTop: 16 }}>
                <button onClick={() => go("maint")}
                    style={{ background: "none", border: "none", color: h.ac, cursor: "pointer", fontSize: 13, marginBottom: 8 }}>
                    &larr; {t.back || "Back"}
                </button>
                <h2 style={{ color: h.tx, fontSize: 18, fontWeight: 700, margin: "0 0 16px" }}>{t.submit || "Submit Request"}</h2>
                <div style={{ ...crd(h), padding: 24, textAlign: "center" }}>
                    <div style={{ fontSize: 40, marginBottom: 12 }}>🔗</div>
                    <div style={{ color: h.tx, fontWeight: 700, fontSize: 16, marginBottom: 8 }}>
                        {t.notLinkedTitle || "Not linked to a landlord yet"}
                    </div>
                    <div style={{ color: h.sc, fontSize: 13, lineHeight: 1.6, marginBottom: 16 }}>
                        {t.notLinkedMaintBody ||
                            "You're not currently linked to any landlord, so there's nobody to receive your maintenance request. Ask your landlord to send you an invitation — once you accept it, you'll be able to submit requests here."}
                    </div>
                    <button onClick={() => go("dash")}
                        style={{ background: h.ac, color: "#fff", border: "none", padding: "10px 20px", borderRadius: 10, fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
                        {t.back || "Back to Dashboard"}
                    </button>
                </div>
            </div>
        );
    }

    const submit = async () => {
        if (!desc || busy) return;
        setBusy(true);
        try {
            const newMaint = { id: `m${Date.now()}`, tid: ct, desc, urg, st: "open", dt: new Date().toISOString().slice(0, 10) };
            // Server-first: don't paint an optimistic row or fire a
            // landlord notification until the server has accepted the
            // write. If the server says no (e.g. tenant got unlinked
            // mid-flow), surface the message and abort.
            const saveRes = await api.saveMaintenance(newMaint);
            if (!saveRes || saveRes.success !== true) {
                throw new Error(saveRes?.error || saveRes?.message || "Server rejected the request. You may not be linked to a landlord.");
            }
            setMts([newMaint, ...mts]);
            addNotif("landlord", null, `${me?.name || "Tenant"} submitted maintenance: "${desc}" (${urg})`, "info");
            addNotif("tenant", ct, `Your maintenance request "${desc}" has been submitted.`, "info");
            flash(t.submitted);
            go("maint");
        } catch (err) {
            flash("Error: " + (err.message || "Could not save request"));
        } finally {
            setBusy(false);
        }
    };

    return <div style={{ paddingTop: 16 }}>
        <button onClick={() => go("maint")} style={{ background: "none", border: "none", color: h.ac, cursor: "pointer", fontSize: 13, marginBottom: 8 }}>&larr; {t.back}</button>
        <h2 style={{ color: h.tx, fontSize: 18, fontWeight: 700, margin: "0 0 16px" }}>{t.submit}</h2>
        <div style={{ ...crd(h), padding: 20 }}>
            <Fld l={t.desc} v={desc} set={sD} h={h} />
            <label style={{ color: h.sc, fontSize: 12, fontWeight: 500, display: "block", marginBottom: 6 }}>{t.urgency}</label>
            <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>{["low", "med", "high"].map(u => <button key={u} onClick={() => sG(u)} style={{ flex: 1, padding: 8, borderRadius: 10, border: `1px solid ${urg === u ? h.ac : h.bd}`, background: urg === u ? `${h.ac}15` : "transparent", color: urg === u ? h.ac : h.sc, cursor: "pointer", fontSize: 12 }}>{u === "low" ? t.low : u === "med" ? t.med : t.high}</button>)}</div>
            <button
                onClick={submit}
                disabled={busy || !desc}
                style={{ ...btnP(h), opacity: (busy || !desc) ? 0.6 : 1, cursor: (busy || !desc) ? "not-allowed" : "pointer" }}>
                {busy ? "..." : t.submit}
            </button>
        </div>
    </div>;
}

export default TenSubMaint;
